import { VIPER_CONST } from "../commonConstant";
import { IAffilateBody, IAffilatiRequestId } from "../types";
import * as BaseApi from "../configs/api-config";

class AffiliateApiService {
  private url = (action: string) => VIPER_CONST.base_url + action;
  fetchThemeById: any;
  getAffiliateTheme: any;

  public async affilateData(request: IAffilateBody): Promise<IAffilatiRequestId | undefined> {
    const body = {
      username: request.username,
      sessionid: request.sessionid,
      failstatus: 0,
      request: request.request
    };
    return BaseApi._post(this.url("getaffiliates"), body);
  }
}
const AffiApi = new AffiliateApiService();
export default AffiApi;
